export enum Tour {
  // A tour created for the update to the new flexlayout-react (FOND version 1.5)
  DYNAMIC_LAYOUT = "dynamicLayout",
  // A tour shown on first project load
  PROJECT_INTRO = "newProject",
}
